import React from 'react';
import { Card } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import {
  ButtonExport,
  ButtonNewRecord,
  FlexRow,
  PageLimitSelect,
  Pagination,
} from '../../common';

const footerPadding = {
  margin: '0px 0.5rem 0px 0px',
};

type Props = {
  readonly pageCount: number;
  readonly pageIndex: number;
  readonly pageSize: number;
  readonly recordCount?: number;
  readonly onPageChange?: (page: number) => void;
  readonly onPageSizeChange?: (size: number) => void;
  readonly onExport?: () => void;
  readonly onNew?: () => void;
  readonly hasPdf?: any;
  readonly hidePagination?: boolean;
  readonly injectFooterElement?: React.ReactNode;
};

const GridFooter = ({
  pageCount,
  pageIndex,
  pageSize,
  recordCount = 0,
  onPageChange = null,
  onPageSizeChange = null,
  onExport = null,
  onNew = null,
  hasPdf = null,
  hidePagination = false,
  injectFooterElement,
}: Props) => {
  const { t, i18n } = useTranslation();
  return (
    //
    //-------------------------------- Render ----------------------
    //
    <Card.Footer>
      <FlexRow id="button-row">
        <span className="d-flex justify-content-center align-items-center">
          {/* -------- INJECT BUTTONS ---------- */}
          {injectFooterElement && (
            <div id="injectFooterElements" style={footerPadding}>
              {injectFooterElement}
            </div>
          )}
          {onExport && (
            <ButtonExport onClick={onExport} disabled={recordCount === 0} />
          )}
          {onNew && <ButtonNewRecord onClick={onNew} />}
          {/* {hasPdf && <PdfButton data={hasPdf} />} */}
        </span>
        {!hidePagination && (
          <span className="d-flex justify-content-center align-items-center">
            <span className="my-0 mx-2">
              <span className="text-secondary">
                {i18n.language === 'gr'
                  ? t('Πλήθος Εγγραφών')
                  : t('No of records')}
                :&nbsp;
              </span>
              {recordCount.toLocaleString()}
            </span>
            {pageCount > 1 && (
              <Pagination
                current={pageIndex}
                total={pageCount}
                onChange={onPageChange}
              />
            )}
            <div className="mx-2" />
            {onPageSizeChange && (
              <PageLimitSelect value={pageSize} onChange={onPageSizeChange} />
            )}
          </span>
        )}
      </FlexRow>
    </Card.Footer>
  );
};

export default React.memo(GridFooter);

